import { CreateControllerFn, IControllerConfig, IUser } from '@wix/yoshi-flow-editor';

import { getLocale } from '../../utils';
import settingsParams from './settingsParams';
import { PageLink } from './types';
import { createSettingsEventHandler, loadData, loadUserData, resolveLink } from './utils';
import { ControllerProps } from './Widget/types';

const createController: CreateControllerFn = async ({ controllerConfig, flowAPI }) => {
  const { setProps, wixCodeApi } = controllerConfig;
  const { settings } = flowAPI;
  const { isEditor } = flowAPI.environment;

  const setWidgetProps = (props: Partial<ControllerProps>) => {
    setProps(props);
  };

  const { subscribeToSettingsChanges, handleSettingsConfigChange } = createSettingsEventHandler(
    flowAPI,
    setWidgetProps,
  );

  setProps({ fitToContentHeight: true });

  return {
    async pageReady() {
      subscribeToSettingsChanges();

      const pageLink = settings.get(settingsParams.pageLink) as PageLink | undefined;
      let isLoggedIn = wixCodeApi.user.currentUser.loggedIn;
      const { loyaltyProgram, pointsBalance, rewardsAvailable } = await loadData(flowAPI);

      wixCodeApi.user.onLogin(async (user: IUser) => {
        isLoggedIn = user.loggedIn;
        const userData = await loadUserData(flowAPI);
        setWidgetProps({ isLoggedIn, ...userData });
      });

      setWidgetProps({
        locale: getLocale(flowAPI),
        isLoggedIn: isEditor ? true : isLoggedIn,
        loyaltyProgram,
        pointsBalance,
        rewardsAvailable,
        userRole: wixCodeApi.user.currentUser.role,
        link: await resolveLink({ pageLink, flowAPI }),
      });
    },
    updateConfig(_$w, newConfig) {
      handleSettingsConfigChange(newConfig as IControllerConfig);
    },
  };
};

export default createController;
